export default function starTransform(input) {
  if (input.length === 0) return input;
  return `★${input}★`;
}
